import { camelCaseToSeparator } from '../common/utils/camelCaseToSeparator';

/**
 * This is the global function that the iframe posts ga messages to
 * @param {*} params 
 */
window.trackGoogleEvent = function (params) {
      var eventName = params.eventName;
      var extraParams = params.extraParams;
      let gaParams = {};

      /*
LoadingFunnel events for registered users:
loadingFunnel_gambinoAppStarted
loadingFunnel_lightweightAuthorizationCompleted
loadingFunnel_loadLobbyResourcesCompleted
loadingFunnel_privacyPolicyShown
loadingFunnel_privacyPolicyAccepted
loadingFunnel_authorizationCompleted
loadingFunnel_getBatchInfoCompleted
loadingFunnel_loadFeatureResourcesCompleted
loadingFunnel_initFeaturePatchesCompleted
loadingFunnel_lobbyInitCompleted
loadingFunnel_lobbyLoaded
loadingFunnel_loginCampaignStarted
loadingFunnel_slotGameIconClicked
loadingFunnel_slotGameLoaded
loadingFunnel_firstSpinInSession

New loadingFunnel events for not registered users (new and existing):
loadingFunnel_unregisteredUser_registrationFormShown
loadingFunnel_unregisteredUser_gambinoAppStarted
loadingFunnel_unregisteredUser_guestLightweightAuthorizationCompleted
loadingFunnel_unregisteredUser_loadLobbyResourcesCompleted
loadingFunnel_unregisteredUser_guestGetBatchInfoCompleted
loadingFunnel_unregisteredUser_guestLoadFeatureResourcesCompleted
loadingFunnel_unregisteredUser_guestInitFeaturePatchesCompleted
loadingFunnel_unregisteredUser_lobbyInitCompleted
loadingFunnel_unregisteredUser_lobbyLoaded
loadingFunnel_unregisteredUser_registrationFlowStarted
loadingFunnel_unregisteredUser_lightweightAuthorizationCompleted
loadingFunnel_unregisteredUser_privacyPolicyShown
loadingFunnel_unregisteredUser_privacyPolicyAccepted
loadingFunnel_unregisteredUser_authorizationCompleted
loadingFunnel_unregisteredUser_getBatchInfoCompleted
loadingFunnel_unregisteredUser_loadFeatureResourcesCompleted
loadingFunnel_unregisteredUser_initFeaturePatchesCompleted
loadingFunnel_unregisteredUser_registrationFlowCompleted
loadingFunnel_unregisteredUser_loginCampaignStarted
loadingFunnel_unregisteredUser_slotGameIconClicked
loadingFunnel_unregisteredUser_slotGameLoaded
loadingFunnel_unregisteredUser_firstSpinInSession
      */

      if (eventName.startsWith('loadingFunnel_')) {
            gaParams['loading_user_type'] = eventName.includes('_unregisteredUser_') ? 'unregistered' : 'registered';
            eventName = camelCaseToSeparator(eventName)?.replace('loading_funnel_', 'load_')?.replace('unregistered_user_', '');

            eventName = eventName.replace('load_load_', 'load_'); // some ended up with load_ twice
            eventName = eventName.substring(0, 40); // GA4 has a 40 character limit
            gaParams['loading_phase'] = eventName.replace('load_', ''); // add loading_phase for all load_* events
            gaParams['nonInteraction'] = true; // these are not user interactions

            // apply userId if it's changed
            if (extraParams?.userId) {
                  // check if it's changed. SessionData was added to gtag in gaInit()
                  if (extraParams.userId && gtag.sessionData.playerStatus && extraParams.userId !== gtag.sessionData.playerStatus.userId) {
                        gtag("set", { "user_id": extraParams.userId });
                        dataLayer.push({ "user_id": extraParams.userId });
                  }
            }

            // handing timing data
            let now = Date.now();
            gaParams['load_timing'] = now - gam.pageloadTs;
            gaParams['load_timing_norm'] = Math.min(gaParams['load_timing'], 60000);
            gaParams['load_timing_delta'] = now - gam.lastTimingTs;
            gaParams['value'] = Math.min(gaParams['load_timing_delta'], 10000); // instead of load_timing_delta_norm
            window.gam.lastTimingTs = now;

            // lobby
            if (eventName === 'load_lobby_loaded') {
                  gaParams['h5_lobby_view'] = 1;
                  if (gaParams['load_timing'] <= 10000) {
                        gaParams['h5_lobby_under_10s'] = 1;
                        gaParams['h5_lobby_time_bucket'] = 'under 10s';
                  } else if (gaParams['load_timing'] <= 15000) {
                        gaParams['h5_lobby_under_15s'] = 1;
                        gaParams['h5_lobby_time_bucket'] = 'under 15s';
                  } else if (gaParams['load_timing'] <= 20000) {
                        gaParams['h5_lobby_under_20s'] = 1;
                        gaParams['h5_lobby_time_bucket'] = 'under 20s';
                  } else if (gaParams['load_timing'] <= 25000) {
                        gaParams['h5_lobby_under_25s'] = 1;
                        gaParams['h5_lobby_time_bucket'] = 'under 25s';
                  } else {
                        gaParams['h5_lobby_over_25s'] = 1;
                        gaParams['h5_lobby_time_bucket'] = 'over 25s';
                  }
            }

            // spin
            if (eventName === 'load_first_spin_in_session') {
                  gaParams['h5_spin'] = 1;
            }

            // send
            gtag("event", eventName, gaParams);

      } else if (['login_show','login_choose_method','login_switch','login_submit','login_success','login_failure'].includes(eventName)) {
            // example props: {"method":"email", "account_status": "new|returning", "type":"register", "error":"[error type]"}
            // target actions (unchanged - same as eventName)
            // target Props: login_method, account_status, login_details, error

            if(extraParams?.method) gaParams['login_method'] = extraParams.method;
            if(extraParams?.account_status) gaParams['account_status'] = extraParams.account_status;
            if(extraParams?.type) gaParams['login_details'] = extraParams.type;
            if(extraParams?.error) gaParams['error'] = extraParams.error;
            if(eventName === 'login_show') gaParams['nonInteraction'] = true;
            
            gtag("event", eventName, gaParams);


      } else {


            // skip some legacy events
            if (['login_success', 
                  'show_lobby', 
                  'slot_first-spin-in-session',
                  'complete_first_authorization',
                  'slot_first-spin',

            ].includes(eventName)) return;

            gtag("event", eventName, extraParams);
      }
}
